import styled from 'styled-components';

// Main Container
export const MainContainer = styled.div<{ maxWidth?: string }>`
  width: 90%;
  max-width: ${(props) => props.maxWidth ?? '1200px'};
  display: flex;
  margin: 0 auto;
  padding: 0 0 30px 40px;
  flex-wrap: wrap;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.down('lg')} {
    width: 95%;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
    max-width: 100%;
    margin: 0;
    flex-wrap: wrap;
    padding: 0px 20px;
  }
`;

// 2 Column Layout
export const FlexColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 0px;
    flex-wrap: wrap;
    width: 100%;
  }
`;

// Single column
export const FlexColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  &:first-child {
    margin-right: 40px;
    min-width: 50%;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;

    &:first-child {
      margin-right: 0;
    }
  }
`;

// White background card body
export const PageBody = styled.div<{
  width?: string;
  padding?: string;
  disableTransparent?: boolean;
  alignItems?: 'center' | 'flex-end' | 'flex-start' | 'space-between';
  height?: string;
}>`
  .MuiFormLabel-root {
    color: ${(props) => props.theme.palette.primary.main};
  }
  width: ${(props) => props.width ?? '100%'};
  height: ${(props) => props.height ?? '100%'};
  padding: ${(props) => props.padding ?? '22px 32px'};
  margin-bottom: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: ${({ alignItems = 'flex-start' }) => alignItems};
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.shadows[24]};
  background-color: ${({ theme }) => theme.palette.background.paper};

  ${(props) => props.theme.breakpoints.down('sm')} {
    ${(props) =>
      props.disableTransparent ? '' : 'background-color: transparent'};
    padding-top: 0;
    padding-bottom: 0;
    box-shadow: none;
  }
`;

// MULTI COLUMN LAYOUTS
export const ColumnLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;

  div {
    flex: 1;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
  }
`;

export const HeaderColumnLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;
